import { render, staticRenderFns } from "./AddLocationIntro.vue?vue&type=template&id=336a56b4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddLocationIntro.vue"
export default component.exports